// Send error notifications to Sentry
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

if (ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: DSN,

    // To set your release version
    release: RELEASE,
    environment: ENVIRONMENT,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}
